var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9784 27.4409L29.0754 27.1095C28.7341 27.0694 28.3881 27.1072 28.0634 27.22C27.7388 27.3328 27.4439 27.5178 27.201 27.7609L25.0981 29.8639C21.8538 28.2135 19.2167 25.5764 17.5663 22.3321L19.6806 20.2177C20.1721 19.7262 20.4121 19.0405 20.3321 18.3433L20.0007 15.4632C19.9361 14.9055 19.6686 14.3911 19.2492 14.018C18.8297 13.645 18.2876 13.4393 17.7263 13.4402H15.749C14.4575 13.4402 13.3832 14.5145 13.4632 15.806C14.0689 25.5665 21.8751 33.3612 31.6241 33.967C32.9156 34.047 33.99 32.9726 33.99 31.6811V29.7039C34.0014 28.5495 33.1328 27.5781 31.9784 27.4409Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamphone);
export default __webpack_public_path__ + "static/media/teamphone.d317249ba12483760bf547b8151c25af.svg";
export { ForwardRef as ReactComponent };